import { KoruLogoCombinedProps } from './types';

const usePresenter = (props: KoruLogoCombinedProps): KoruLogoCombinedProps => {
  return props;
};

export default usePresenter;
